module.exports = __webpack_public_path__ + "static/azul_logo-2bf5aaa2b26acdfe838b6abbed9db197.svg";